import { api } from '@/api'
import type { OnboardingStatus, OnboardingStep } from '@/modules/hub/types'

export const getOnboardingStatus = (): Promise<OnboardingStatus> => api.get('onboarding/status').json<OnboardingStatus>()

export const completeOnboardingStep = (step: OnboardingStep): Promise<void> =>
  api.post('onboarding/steps/complete', { json: { step } }).json()
